import { MultiselectCategoryCardCSSStyleImpl } from '../../../login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectcategorycardcssstyle';
import { Fonts } from '../../../../../utils/resources/fonts';
import { Colors } from '../../../../../utils/resources/colors';
export class PreferenceCategoryCardCSSStyleImpl extends MultiselectCategoryCardCSSStyleImpl
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '160px', 
            width: '121px', 
            objectFit: 'cover', 
            position: 'relative',
            marginRight:'10px'
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '121px', 
            height: '129px',
            borderRadius: "5px"
        };
    }

    getTintDivCSSStyle(): object{
        return {
            position: "absolute",
            width: '121px', 
            height: '129px',
            display: "flex",
            borderRadius: "5px",
            cursor: "pointer",
            background: "linear-gradient(0deg, rgb(27, 25, 25, 0.73) 0%, rgb(218, 60, 128, 0.73) 100%)",
        };
    }

    getTitleCSSStyle(): object {
        return {
            // display: "flex",
            textAlign: "left",
            width: '100%', 
            height: '29px',
            fontWeight: "900",
            marginTop: "5px",
            letterSpacing: 0,
            overflow: "hidden",
            textOverflow: 'ellipsis',
            fontSize: this.getResources().getFont(Fonts.h15),
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getCheckboxCSSStyle(): object 
    {
        return {
            position: "absolute",
            top: "8px",
            alignItems: 'right', 
            right: "90px",
            left: "90px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferenccard/preferencecategorycardcssstyle.tsx